<template>
  <v-container class="ma-0 pa-0">
    <!-- PROGRESS BAR PLAYER -->
    <v-card min-width="512" max-width="512" height="5" color="white">
      <v-progress-linear v-model="progressValue" height="5"></v-progress-linear>
    </v-card>
    <!-- PLAYER -->
    <v-card min-width="512" max-width="512" class="px-3" color="grey darken-4">
      <!-- INFO EVENTS -->
      <v-layout style="max-height:40px;" py-2 align-center>
        <!-- EVENT # -->
        <div style="color:gray;" class="caption pl-1 pr-2">
          Evento: {{ counterEvents + 1 }} / {{ eventsToPlay.length }}
        </div>
        <v-divider vertical></v-divider>
        <!-- DATE -->
        <v-icon class="pl-2" size="21" color="grey">event</v-icon>
        <h6>{{ eventsToPlay[counterEvents].time | filterDate }}</h6>
        <!-- TIME -->
        <v-icon class="pl-2" size="21" color="grey">access_time</v-icon>
        <h6>{{ eventsToPlay[counterEvents].time | filterTime }}</h6>
        <!-- LAT & LNG -->
        <div style="min-width:160px;max-width:160px;" class="pl-2 pt-1">
          <p class="caption">
            <b class="caption">Lat:</b>
            {{ eventsToPlay[counterEvents].lat }}
          </p>
          <p style="margin-top:-8px;" class="caption">
            <b class="caption">Lng:</b>
            {{ eventsToPlay[counterEvents].lng }}
          </p>
        </div>
        <!-- SHOW INFO CURRENT EVENT -->
        <v-tooltip v-model="showInfo" color="grey darken-4" top>
          <template v-slot:activator="{ click }">
            <transition name="slide-fade">
              <div v-if="isPaused"  style="min-width:16px;max-width:16px;" class="pl-2">
                <v-btn
                  flat
                  icon
                  small
                  v-on="click"
                  @click="showInfoCurrentEvent"
                >
                  <v-icon size="18">info</v-icon>
                </v-btn>
              </div>
            </transition>
          </template>
          <!-- INFO CONTENT -->
          <span>
            <v-flex class="text-xs-left">
              <p><b>Evento:</b>
                {{ eventTypeName(eventsToPlay[counterEvents].eventType) }}
              </p>
              <p><b>Vel:</b>
                {{ eventsToPlay[counterEvents].speed }} Km/h
              </p>
              <p><b>Señal:</b>
                {{ eventsToPlay[counterEvents].metadata.GPSValid ? 'Con Señal' : 'Sin Señal' }}
              </p>
              <p><b>Batería Vehículo:</b>
                {{ eventsToPlay[counterEvents].metadata.mainBatteryVoltage }} V
              </p>
              <p><b>Satélites:</b>
                {{ eventsToPlay[counterEvents].metadata.numberOfSatellites }}
              </p>
              <p><b>Rumbo:</b>
                {{ eventsToPlay[counterEvents].direction }}˚
              </p>
            </v-flex>
          </span>
        </v-tooltip>
      </v-layout>
      <v-divider></v-divider>
      <!-- CONTROLS PLAYER -->
      <v-layout style="max-height:55px;" align-center py-2>
        <!-- TITLE -->
        <v-flex style="min-width:110px;max-width:110px;" px-2>
          <h3>Reproducir Recorrido</h3>
        </v-flex>
        <v-divider vertical></v-divider>
        <v-layout justify-center px-2>
          <!-- REWIND -->
          <v-layout justify-center>
            <div>
              <v-btn
                small
                outline
                fab
                :disabled="counterEvents === 0 || isInFastRewind"
                @click="fastRewind"
              >
                <v-icon>fast_rewind</v-icon>
              </v-btn>
            </div>
          </v-layout>
          <!-- PLAY/PAUSE -->
          <v-layout justify-center>
            <!-- PLAY -->
            <div v-if="isPaused || isInFastForward || isInFastRewind">
              <v-btn
                small
                outline
                fab
                :disabled='finishedRoutePlay'
                @click="playRoute(false)"
              >
                <v-icon>play_arrow</v-icon>
              </v-btn>
            </div>
            <!-- PAUSE -->
            <div v-else>
              <v-btn small outline fab @click="pauseRoute">
                <v-icon>pause</v-icon>
              </v-btn>
            </div>
          </v-layout>
          <!-- FAST FORWARD -->
          <v-layout justify-center>
            <div>
              <v-btn
                small
                outline
                fab
                :disabled="isInFastForward"
                @click="fastForward"
              >
                <v-icon>fast_forward</v-icon>
              </v-btn>
            </div>
          </v-layout>
          <!-- RESTART -->
          <v-layout justify-center>
            <div>
              <v-btn small outline fab :disabled="!canRestart" @click="restart">
                <v-icon>restart_alt</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-layout>
        <v-divider vertical></v-divider>
        <!-- CLOSE -->
        <v-flex style="min-width:100px;max-width:100px;" d-inline-flex align-center pl-3>
          <v-flex class="caption">Cerrar</v-flex>
          <v-flex>
            <v-btn small outline fab @click="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
import { eventsTypeMap } from '../utils/eventsType'

export default {
  name: 'route-player',
  props: {
    routeEvents: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isPaused: true,
      canRestart: false,
      progressValue: 0,
      intervalValuePlayer: 1200,
      eventsToPlay: [],
      percentStep: null,
      counterEvents: 0,
      middleInterval: null,
      middleIntervalStep: 17,
      finishedRoutePlay: false,
      routeEventsPlayer: this.routeEvents,
      showInfo: false,
      isInFastRewind: false,
      isInFastForward: false,
      actionFromFRandFFButton: false
    }
  },
  watch: {
    progressValue(newValue) {
      // console.log('PROGRESS VALUE', newValue, oldValue)
      if (newValue === 0) {
        this.$nextTick(() => {
          // console.log('RESTART', newValue)
          this.canRestart = false
          this.finishedRoutePlay = false
          this.progressValue = 0
          this.counterEvents = 0
          this.isInFastForward = false
          this.isInFastRewind = false
          this.isPaused = true
        })
      }
    },
    finishedRoutePlay(newValue) {
      // console.log('FINISHED ROUTE PLAY', newValue, oldValue)
      if (newValue) {
        this.isInFastForward = true
      }
    }
  },
  methods: {
    async playRoute(from) {
      // console.log('PLAY ROUTE', from, this.isInFastRewind)
      this.actionFromFRandFFButton = from
      if (this.isInFastForward && !this.actionFromFRandFFButton) {
        this.isInFastForward = false
        this.middleIntervalStep = 17
      } else if (this.isInFastRewind && !this.actionFromFRandFFButton) {
        this.isInFastRewind = false
        this.middleIntervalStep = 17
      }
      this.showInfo = false
      this.isPaused = false
      this.canRestart = false
      // PROCESS FAST REWIND
      if (this.isInFastRewind) {
        // console.log('isInFastRewind', this.isInFastRewind, this.counterEvents)
        for (let index = this.counterEvents; index >= 0; index--) {
          this.middleIntervalStep = 5
          // console.log('index', index)
          await this.processPlayer()
          this.counterEvents--
          // console.log('playRoute isInFastRewind INDEX: ', index)
          if (!this.isPaused && !this.isInFastRewind) {
            break
          } else if (this.isInFastForward) break
        }
        if (!this.isPaused && !this.isInFastRewind) this.playRoute(false)
        else if (this.isInFastForward) this.playRoute(false)
      } else { // PROCESS PLAY OR FAST FORWARD
        for (let index = this.counterEvents; index < this.eventsToPlay.length; index++) {
          await this.processPlayer()
          this.counterEvents++
          // console.log('playRoute INDEX: ', index)
          if (this.isPaused) {
            this.$emit('processCurrentEventFromPlayer', this.eventsToPlay[this.counterEvents])
            break
          } else if (this.isInFastRewind) break
        }
        if (this.isInFastRewind) this.playRoute(true)
      }
    },
    pauseRoute() {
      this.isPaused = true
      this.canRestart = true
      this.isInFastForward = false
      this.isInFastRewind = false
    },
    close() {
      this.$emit('closeRoutePlayer')
    },
    restart() {
      this.canRestart = false
      this.finishedRoutePlay = false
      this.progressValue = 0
      this.counterEvents = 0
      this.isInFastForward = false
      this.isInFastRewind = false
      this.initEventData()
    },
    processPlayer() {
      return new Promise(resolve => {
        // PROCESS FAST REWIND
        // console.log('PROCESS PLAYER', this.isInFastRewind)
        if (this.isInFastRewind) {
          if (this.counterEvents > 0) {
            // console.log('counterEvents FR', this.counterEvents)
            this.progressValue -= this.percentStep

            this.$emit('processCurrentEventFromPlayer', this.eventsToPlay[this.counterEvents])

            const currentEvent = {}
            Object.assign(currentEvent, this.eventsToPlay[this.counterEvents])
            const currentLat = this.eventsToPlay[this.counterEvents].lat
            const currentLng = this.eventsToPlay[this.counterEvents].lng
            const prevLat = this.eventsToPlay[this.counterEvents - 1].lat
            const prevLng = this.eventsToPlay[this.counterEvents - 1].lng
            const stepLat = (currentLat - prevLat) / this.middleIntervalStep
            const stepLng = (currentLng - prevLng) / this.middleIntervalStep
            const intervalStep = 31
            let counterIn = 1
            // To avoid overlap
            if (this.middleInterval !== null) {
              clearInterval(this.middleInterval)
              this.middleInterval = null
            }
            // Interval to move marker between events
            this.middleInterval = setInterval(() => {
              if (counterIn < this.middleIntervalStep) {
                // console.log('counterIn: ', counterIn)
                currentEvent.lat -= stepLat
                currentEvent.lng -= stepLng
                this.$emit('processCurrentEventFromPlayer', currentEvent)
                counterIn++
              } else {
                clearInterval(this.middleInterval)
                this.middleInterval = null
                counterIn = 1
                resolve(true)
              }
            }, intervalStep)
          } else {
            // if (!this.finishedRoutePlay) {
            // console.log('FINISHED FR', this.counterEvents)
            this.canRestart = false
            this.progressValue = 0
            this.$emit('processCurrentEventFromPlayer', this.eventsToPlay[this.counterEvents])
            this.isPaused = false
            this.isInFastRewind = false
            this.middleIntervalStep = 17
            // }
          }
        } else { // PROCESS PLAY OR FAST FORWARD
          if (this.isInFastRewind) this.isInFastRewind = false

          if (this.counterEvents < this.eventsToPlay.length - 1) {
            this.progressValue += this.percentStep

            this.$emit('processCurrentEventFromPlayer', this.eventsToPlay[this.counterEvents])

            const currentEvent = {}
            Object.assign(currentEvent, this.eventsToPlay[this.counterEvents])
            const currentLat = this.eventsToPlay[this.counterEvents].lat
            const currentLng = this.eventsToPlay[this.counterEvents].lng
            const nextLat = this.eventsToPlay[this.counterEvents + 1].lat
            const nextLng = this.eventsToPlay[this.counterEvents + 1].lng
            const stepLat = (nextLat - currentLat) / this.middleIntervalStep
            const stepLng = (nextLng - currentLng) / this.middleIntervalStep
            // console.log('stepLat PLAY', stepLat)
            // console.log('stepLng PLAY', stepLng)
            const intervalStep = 31
            let counterIn = 1
            // To avoid overlap
            if (this.middleInterval !== null) {
              clearInterval(this.middleInterval)
              this.middleInterval = null
            }
            // Interval to move marker between events
            this.middleInterval = setInterval(() => {
              if (counterIn < this.middleIntervalStep) {
                // console.log('counterIn: ', counterIn)
                currentEvent.lat += stepLat
                currentEvent.lng += stepLng
                this.$emit('processCurrentEventFromPlayer', currentEvent)
                counterIn++
              } else {
                clearInterval(this.middleInterval)
                this.middleInterval = null
                counterIn = 1
                resolve(true)
              }
            }, intervalStep)
          } else {
            // console.log('finishedRoutePlay', this.finishedRoutePlay)
            if (!this.finishedRoutePlay) {
              this.finishedRoutePlay = true
              this.canRestart = true
              this.progressValue += this.percentStep
              this.$emit('processCurrentEventFromPlayer', this.eventsToPlay[this.counterEvents])
              this.isPaused = true
              this.isInFastForward = false
            }
          }
        }
      })
    },
    initEventData() {
      // const routeEventsPlayer = []
      // Object.assign(routeEventsPlayer, this.routeEvents)
      // console.log('routeEventsPlayer: ', routeEventsPlayer)
      this.eventsToPlay = []
      let eventsToPlayTemp = []
      this.routeEventsPlayer.forEach(element => {
        // console.log('ELEMENT: ', element)
        eventsToPlayTemp = [...element]
      })
      eventsToPlayTemp = eventsToPlayTemp.reverse()
      this.$emit('processCurrentEventFromPlayer', eventsToPlayTemp[0])
      for (let index = 0; index < eventsToPlayTemp.length; index++) {
        const element = eventsToPlayTemp[index]
        if (
          element.eventType === 11 ||
          element.eventType === 44 ||
          element.eventType === 53 ||
          element.eventType === 69 ||
          element.eventType === 204
        ) this.eventsToPlay.push(element)
      }
      this.percentStep = 100 / this.eventsToPlay.length
      // console.log('EVENTS: ', this.eventsToPlay.length, this.percentStep)
    },
    showInfoCurrentEvent() {
      this.showInfo = !this.showInfo
    },
    eventTypeName(key) {
      const eventTypeName = eventsTypeMap.get(key)
      return eventTypeName
    },
    fastRewind() {
      // console.log('fastRewind')
      if (this.isPaused) this.playRoute(this.finishedRoutePlay)
      // this.playRoute(this.finishedRoutePlay)
      this.isInFastForward = false
      this.isInFastRewind = true
      this.middleIntervalStep = 5
      if (this.finishedRoutePlay) {
        this.playRoute(this.finishedRoutePlay)
        this.finishedRoutePlay = false
      }
    },
    fastForward() {
      // console.log('fastForward')
      if (this.isPaused) this.playRoute(false)
      // this.playRoute(false)
      this.isInFastRewind = false
      this.isInFastForward = true
      this.middleIntervalStep = 5
      // console.log('middleIntervalStep', this.middleIntervalStep)
    }
  },
  created() {
    // console.log('ACTIVATED - routeEvents', this.routeEvents)
    this.initEventData()
  },
  beforeDestroy() {
    clearInterval(this.middleInterval)
  }
}
</script>

<style lang="scss" scoped>
h3 {
  line-height: 16px;
}

h6 {
  font-size: 14px;
  font-weight: 500;
  color: white;
}

p {
  margin-bottom: 5px;
}

b {
  color: gray;
}

.slide-fade-enter-active {
  transition: all .5s ease;
}
.slide-fade-leave-active {
  transition: all .25s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/RoutePlayer.vue